module.exports = __webpack_public_path__ + "media/images/categories/carousel/international-politics-0e3c991ab16062df026910440b5ee280.jpg";